import { useTranslation } from 'react-i18next';

import { FinanceStatisticsContainer } from '~features/statistics';

import Page from '../page';

const RevenueStatisticsPage = () => {
	const { t } = useTranslation();

	return (
		<Page title={`${t('data')} - ${t('nav.financialReports.revenue')}`}>
			<FinanceStatisticsContainer />
		</Page>
	);
};

export default RevenueStatisticsPage;
